import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../config/environments/environment';
import { News } from '../models/interfaces/news';
import { Observable } from 'rxjs';
import { User } from '../models/interfaces/user.interface';
import { PageDto } from '../models/dto/arrival/page.dto';
import { OccasionParamsDto } from '../models/dto/occasion-params.dto';
import { NewsSummaryDto } from 'src/app/modules/news/dtos/news-summary.dto';

@Injectable()
export class NewsService {
  private readonly filterByUserPath = 'filterbyuser';
  private readonly newsPath = 'news';
  private readonly summaryPath = 'summary';

  constructor(private http: HttpClient) {}

  public getAll(params?: OccasionParamsDto): Observable<PageDto<News>> {
    const url = `${environment.api.baseUrl}/${this.newsPath}/v2`;
    return this.http.get<PageDto<News>>(url, {
      params: this.buildHttpParams(params),
    });
  }

  public getSummary(id: string): Promise<NewsSummaryDto> {
    return this.http
      .get<NewsSummaryDto>(
        `${environment.api.baseUrl}/${this.newsPath}/${id}/${this.summaryPath}/v2`
      )
      .toPromise();
  }

  public getById(id: string): Observable<News> {
    return this.http.get<News>(
      `${environment.api.baseUrl}/${this.newsPath}/${id}`
    );
  }

  public getAllByUserId(userId: string): Observable<News[]> {
    return this.http.get<News[]>(
      `${environment.api.baseUrl}/${this.newsPath}/${userId}`
    );
  }

  public getByUserId(user: User): Observable<News[]> {
    return this.http.get<News[]>(
      `${environment.api.baseUrl}/${this.newsPath}/${this.filterByUserPath}/${user.id}`
    );
  }

  public save(news: News): Observable<string> {
    return this.http.post(`${environment.api.baseUrl}/${this.newsPath}`, news, {
      responseType: 'text',
    });
  }

  public update(news: News): Observable<string> {
    return this.http.put(
      `${environment.api.baseUrl}/${this.newsPath}/v2/${news.id}`,
      news,
      { responseType: 'text' }
    );
  }

  public delete(newsId: string): Observable<string> {
    return this.http.delete(
      `${environment.api.baseUrl}/${this.newsPath}/${newsId}`,
      { responseType: 'text' }
    );
  }

  private buildHttpParams(params?: OccasionParamsDto): any {
    const httpParams: any = {};

    if (params?.year) {
      httpParams.year = params.year;
    }

    if (params?.month) {
      httpParams.month = params.month;
    }

    if (params?.released) {
      httpParams.released = params.released;
    }

    if (params?.scheduled) {
      httpParams.scheduled = params.scheduled;
    }

    if (params?.limit) {
      httpParams.limit = params.limit;
    }

    if (params?.page) {
      httpParams.page = params.page;
    }

    if (params?.idSchool) {
      httpParams.idSchool = params.idSchool;
    }

    if (params?.idsClassrooms && params?.idsClassrooms.length > 0) {
      httpParams.idsClassrooms = params.idsClassrooms.join(',');
    }

    if (params?.textSearch) {
      httpParams.textSearch = params.textSearch;
    }

    if (params?.hasAuthorization != null) {
      httpParams.hasAuthorization = params.hasAuthorization;
    }

    return httpParams;
  }
}
